<template>
  <div class="contain">
          <div class="content ">
            <div class="record-item-cont " v-for="(item,index) in subList" :key="index">
              <div class="line" v-if="item.deductionReason">
                <div class="txt">
                  <span class="txt-tit">扣分原因：</span>
                  <span class="txt-cont">{{item.deductionReason}}</span>
                </div>
                <div class="score">-{{item.deduction}}分</div>
              </div>
              <div class="line" v-if="item.respTime">
                <div class="txt">
                  <span class="txt-tit">响应时长：</span>
                  <span class="txt-cont">{{item.respTime}}分钟</span>
                </div>
              </div>
              <div class="line" v-if="item.doneTime">
                <div class="txt">
                  <span class="txt-tit">处理时长：</span>
                  <span class="txt-cont">{{item.doneTime}}</span>
                </div>
              </div>
              <div class="line" v-if="item.accidentTime">
                <div class="txt">
                  <span class="txt-tit">发生时间：</span>
                  <span class="txt-cont">{{item.accidentTime}}</span>
                </div>
              </div>
              <div class="line" v-if="item.deductionTime">
                <div class="txt">
                  <span class="txt-tit">扣分时间：</span>
                  <span class="txt-cont">{{item.deductionTime}}</span>
                </div>
              </div>
              <div class="line" @click="navToDetail(item)">
                <div class="to-detail">
                  <div>查看详情</div><img src="../../assets/image/tb-right.png"/>
                </div>
              </div>
            </div>
          </div>
  </div>
</template>

<script>
  // 扣分记录列表
    export default {
        name: 'causeDeduction',
        data () {
            return {
                onHide: false,
                subList: [],
                subName: '',
                subType: ''

            }
        },
        methods: {
            // 跳转详情页
            navToDetail (row) {
                sessionStorage.setItem('responCont', JSON.stringify(row))
                this.$router.push({
                    path: '/appraise/deductionDetail',
                    query: {
                        subType: this.subType,
                        subName: this.subName
                    }
                });
            }
        },
        mounted () {
            window.yyn.invokeJSB(
                'setTitle',
                {
                    title: sessionStorage.getItem('projectName') || '扣分列表'
                },
                cb => {

                }
            );
        },
        created () {
            this.subList = JSON.parse(sessionStorage.getItem('list')).subList
            this.subName = JSON.parse(sessionStorage.getItem('list')).subName
            this.subType = JSON.parse(sessionStorage.getItem('list')).subType
            console.log(this.subList)
        }
    }
</script>

<style lang="less" scoped>
  .contain {
    min-height: 100vh;
    padding-bottom: 24px;
    padding-top: 24px;
    background: #fbfbfb;
          .content{
            margin: 0 12px;
            height:auto;
            background:rgba(255,255,255,1);
              box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
              border-radius:3px;
            .record-item-cont {
              line-height: 20px;
              transition: all .2s;
              // border-bottom: solid 1Px #EEEEEE;
              padding:12px 16px;

              .line {
                display: flex;
                justify-content: space-between;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                margin-bottom: 8px;
                // line-height: 20px;
                // height: 20px;
                .txt {
                  display: flex;

                  &-tit {
                    // width: 60px;
                  }

                  &-cont {
                    width: 192px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }
                }

                .score {
                  color: #FF4D4D;
                }

                .to-detail {
                  position: relative;
                  color: #36B374;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-top: 4px;
                  height: 12px;
                  width: 80px;
                  div{
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 50px;
                    line-height: 12px;
                  }
                  img{
                    position: absolute;
                    left: 50px;
                    top: -1px;
                    width: 12px;
                    height: 12px;
                  }
                }
              }

              .line:last-child {
                margin-bottom: 0;
              }
            }
            .record-item-cont:last-child{
              border-bottom: 0;
            }
          .ts-list{
            padding-top: 12px;
            text-align: center;
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(155,155,155,1);
            line-height:17px;
            span{
              padding-right: 10px;
              background: url(../../assets/image/t-right.png) no-repeat;
              background-size: 8px 8px;
              background-position: right center;
            }
          }
          }

  }
</style>
